module.exports = __webpack_public_path__ + "img/plan-3.1aab0fdb.png";